// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c7lqD","title":"Header_title__1-kRX","side":"Header_side__Vawuu"};